// extracted by mini-css-extract-plugin
export var apply = "Diy-module--apply--2e41a";
export var applyButton = "Diy-module--applyButton--dc79e";
export var btn = "Diy-module--btn--5f3ee";
export var buttonContainer = "Diy-module--buttonContainer--87d1c";
export var diyLabel = "Diy-module--diyLabel--e3959";
export var formControl = "Diy-module--form-control--36772";
export var formLabel = "Diy-module--form-label--fa3a0";
export var interactivityEdit = "Diy-module--interactivityEdit--d454a";
export var interactivityEditVertical = "Diy-module--interactivityEditVertical--6ce54";
export var labelHeading = "Diy-module--labelHeading--dfe95";
export var logoLabel = "Diy-module--logoLabel--3aa86";
export var name = "Diy-module--name--22b03";
export var personalizationForm = "Diy-module--personalizationForm--1e31b";